import { Col, Row } from 'antd';
import React from 'react';
import SafetyAnomalyColumn from './SafetyAnomalyColumn';
import { ANOMALY_TYPE } from '../../../../utilities/constants';
import { ReactComponent as driverAnomalyAlert } from '../../../../assets/icons/driverAnomalyAlert.svg';
import { ReactComponent as warningAlert } from '../../../../assets/icons/majorAlert.svg';
import { ReactComponent as moderateAlert } from '../../../../assets/icons/minorAlert.svg';
import PropTypes from 'prop-types';

const AnomalyColumns = ({ anomalyData, loading }) => {
  return (
    <Row className="full-height safety-anomaly-row" gutter={[10, 10]}>
      <Col lg={8} xs={24} className="full-height overview-chart-spinner">
        {/* <SafetyAnomalyColumn
          title={ANOMALY_TYPE.CRITICAL}
          headerIcon={criticalAlert}
          count={anomalyData && anomalyData[ANOMALY_TYPE.CRITICAL]?.length}
          topBorderColor="var(--critical-anomaly-color, #FF2124)"
          dataList={anomalyData && anomalyData[ANOMALY_TYPE.CRITICAL]}
        /> */}
        <SafetyAnomalyColumn
          title={ANOMALY_TYPE.DRIVER_ANOMALIES}
          headerIcon={driverAnomalyAlert}
          count={anomalyData?.[ANOMALY_TYPE.DRIVER_DROWSINESS]?.length}
          topBorderColor="var(--driver-anomaly-color-selected, #FF2124)"
          dataList={anomalyData?.[ANOMALY_TYPE.DRIVER_DROWSINESS]}
          loading={loading}
        />
      </Col>
      <Col lg={8} xs={24} className="full-height overview-chart-spinner">
        <SafetyAnomalyColumn
          title={ANOMALY_TYPE.MAJOR}
          headerIcon={warningAlert}
          count={anomalyData?.[ANOMALY_TYPE.MAJOR]?.length}
          topBorderColor="var(--major-anomaly-color-selected, #EEC100)"
          dataList={anomalyData?.[ANOMALY_TYPE.MAJOR]}
          loading={loading}
        />
      </Col>
      <Col lg={8} xs={24} className="full-height overview-chart-spinner">
        <SafetyAnomalyColumn
          title={ANOMALY_TYPE.MINOR}
          headerIcon={moderateAlert}
          count={anomalyData?.[ANOMALY_TYPE.MINOR]?.length}
          topBorderColor="var(--minor-anomaly-color-selected, #54ABA5)"
          dataList={anomalyData?.[ANOMALY_TYPE.MINOR]}
          loading={loading}
        />
      </Col>
    </Row>
  );
};

AnomalyColumns.propTypes = {
  anomalyData: PropTypes.object,
  loading: PropTypes.bool.isRequired,
};

export default React.memo(AnomalyColumns);
